import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileSizePipe } from '../../pipes/file-size.pipe';


@Component({
  selector: 'file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

  @Input() maxFileSize: number = 20971520;
  @Input() supportedFileTypes: string[];

  @Output() uploadHandler = new EventEmitter<any>();
  @Output() onSelect = new EventEmitter<any>();
  @Output() onFileSizeLimitExceeded = new EventEmitter<string>();
  @Output() onFileTypeNotSupported = new EventEmitter<string>();

  constructor(private fileSizePipe: FileSizePipe) { }

  ngOnInit() {
  }

  fileUploadEvent(event) {
    const unsupportedFiles = this.getUnsupportedFiles(event.files).map(x=> x.name);
    const filteredFiles = event.files.filter((file: File) => {
      return unsupportedFiles.indexOf(file.name) == -1;
    });
    event.files = filteredFiles;
    this.uploadHandler.emit(event);
  }

  onSelectEvent(event) {
    const files: FileList = event.files;
    const unsupportedFiles = this.getUnsupportedFiles(files);
    const largeFiles = Array.from(files).filter(f => f.size > this.maxFileSize);

    if (unsupportedFiles.length > 0) {
      const firstUnsupportedFile = unsupportedFiles[0];
      const filename = firstUnsupportedFile.name;
      const message = `${filename} - File type not allowed`;
      this.onFileTypeNotSupported.emit(message);
    } else if (largeFiles.length > 0) {
      const firstLargeFile = largeFiles[0];
      const filename = firstLargeFile.name;
      const filesize = this.fileSizePipe.transform(this.maxFileSize);
      const message = `${filename} - Exceeds ${filesize} file size limit`;
      this.onFileSizeLimitExceeded.emit(message);
    } else {
      this.onSelect.emit(event);
    }
  }

  private getUnsupportedFiles(files: FileList): Array<File> {
    if (this.supportedFileTypes) {
      const supportedTypes = this.supportedFileTypes.map(ext => ext.toLocaleLowerCase());
      const unsupportedFiles = Array.from(files).filter(f => supportedTypes.indexOf(this.extractFileType(f.type)) === -1);
      return unsupportedFiles;
    } else {
      return [];
    }
  }

  private extractFileType(type: string) {
    if (type.indexOf('/') !== -1) {
      return type.split('/').pop().toLowerCase();
    } else {
      return type.split('.').pop().toLowerCase();
    }
  }
}
